/* tslint:disable */
import { BusinessDataProperty } from "./BusinessDataProperty"

export class DecisionServiceVersionBusinessData {
		BusinessDataId: number;
		Version: number;
		Name: string;
		Type: string;
		Question: string;

		Properties: BusinessDataProperty[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersionBusinessData.ts